import React from 'react';
import { SecureUserHtml } from '@wix/wix-emails-secure-components';
import { WrapperItem } from '../components/wrapper-item';
import { Column } from '../components/column';
import { ColumnItem } from '../components/column-item';
import { Section } from '../components/section';
export function SectionHtml(props) {
    const { section, cssClass, columnCssClass } = props;
    const { backgroundColor, borderBottom, borderLeft, borderRight, borderTop } = section;
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: backgroundColor, borderBottom: borderBottom, borderLeft: borderLeft, borderRight: borderRight, borderTop: borderTop, cssClass: cssClass, padding: "0" },
            React.createElement(Column, { cssClass: columnCssClass },
                React.createElement(ColumnItem, null,
                    React.createElement("div", { style: { fontSize: '18px', lineHeight: '28px' } },
                        React.createElement(SecureUserHtml, { html: section.html })))))));
}
//# sourceMappingURL=section-html.js.map